document.documentElement.classList.remove("no-js");

document.addEventListener("DOMContentLoaded", () => {
  forcePdpSizeCss();
  document.querySelectorAll("[data-section-id]").forEach((section) => {
    const selectedDelivery = section.querySelector("[data-delivery-option].is-selected");
    if (selectedDelivery) updateDeliveryDate(section, selectedDelivery.dataset.deliveryOption);
    updateProductVariant(section);
  });
  restoreBrandMomentCards();
  initHeroCarousels();
  hydrateProductGrids();
  initHeaderSearch();
});

function forcePdpSizeCss() {
  if (!document.querySelector(".ff-pdp-v2")) return;
  if (document.querySelector("[data-pdp-size-match-css]")) return;
  const cssLink = document.querySelector("link[href*='farfetch-template.css']");
  const href = cssLink ? cssLink.href.split("&v=")[0] : "/cdn/shop/t/5/assets/farfetch-template.css";
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = `${href}&v=pdp-size-match-20260609-1418`;
  link.setAttribute("data-pdp-size-match-css", "true");
  document.head.appendChild(link);
}

document.addEventListener("click", (event) => {
  const openButton = event.target.closest("[data-menu-open]");
  const closeButton = event.target.closest("[data-menu-close]");
  const drawer = document.querySelector("[data-menu-drawer]");
  if (openButton && drawer) {
    drawer.setAttribute("aria-hidden", "false");
    document.body.classList.add("ff-menu-open");
  }
  if (closeButton && drawer) {
    drawer.setAttribute("aria-hidden", "true");
    document.body.classList.remove("ff-menu-open");
  }

  const searchOpen = event.target.closest("[data-search-open]");
  if (searchOpen) {
    const header = searchOpen.closest("[data-ff-header]");
    const input = header ? header.querySelector(".ff-header__mobile-search [data-search-input]") : null;
    if (header) header.classList.add("is-search-open");
    if (input) window.setTimeout(() => input.focus(), 30);
  }

  const searchClose = event.target.closest("[data-search-close]");
  if (searchClose) {
    const header = searchClose.closest("[data-ff-header]");
    if (header) {
      header.classList.remove("is-search-open");
      header.querySelectorAll("[data-search-results]").forEach((results) => {
        results.hidden = true;
        results.innerHTML = "";
      });
    }
  }

  const filterButton = event.target.closest("[data-filter-toggle]");
  if (filterButton) {
    const panel = document.querySelector("[data-filter-panel]");
    if (panel) panel.hidden = !panel.hidden;
  }

  const viewMoreLink = event.target.closest("[data-view-more-link]");
  if (viewMoreLink) {
    event.preventDefault();

    const pagination = viewMoreLink.closest("[data-view-more]");
    const grid = document.querySelector("[data-products-grid]");
    if (!pagination || !grid || viewMoreLink.getAttribute("aria-busy") === "true") return;

    const originalText = viewMoreLink.textContent;
    viewMoreLink.setAttribute("aria-busy", "true");
    viewMoreLink.textContent = "Loading";

    fetch(viewMoreLink.href)
      .then((response) => response.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const nextGrid = doc.querySelector("[data-products-grid]");
        const nextLink = doc.querySelector("[data-view-more-link]");

        if (nextGrid) {
          grid.insertAdjacentHTML("beforeend", nextGrid.innerHTML);
        }

        if (nextLink) {
          viewMoreLink.href = nextLink.href;
          viewMoreLink.textContent = originalText;
          viewMoreLink.removeAttribute("aria-busy");
        } else {
          pagination.remove();
        }
      })
      .catch(() => {
        viewMoreLink.textContent = originalText;
        viewMoreLink.removeAttribute("aria-busy");
      });
  }

  const deliveryOption = event.target.closest("[data-delivery-option]");
  if (deliveryOption) {
    const group = deliveryOption.closest("[role='group']");
    const section = deliveryOption.closest("[data-section-id]");

    if (group) {
      group.querySelectorAll("[data-delivery-option]").forEach((button) => button.classList.remove("is-selected"));
    }

    deliveryOption.classList.add("is-selected");
    updateDeliveryDate(section, deliveryOption.dataset.deliveryOption);
    if (section) updateProductVariant(section);
  }
});

document.addEventListener("keydown", (event) => {
  if (event.key !== "Escape") return;
  const header = document.querySelector("[data-ff-header].is-search-open");
  if (!header) return;
  header.classList.remove("is-search-open");
  header.querySelectorAll("[data-search-results]").forEach((results) => {
    results.hidden = true;
    results.innerHTML = "";
  });
});

function updateDeliveryDate(section, deliveryValue) {
  if (!section) return;
  const deliveryDate = section.querySelector("[data-delivery-date]");
  const dateMap = {
    "18-20 Days": "18 Jun - 20 Jun",
    "3-5 Days": "5 Jun - 12 Jun",
    "Next Day": "3 Jun - 5 Jun",
    "1-3 Days": "3 Jun - 5 Jun",
  };

  if (deliveryDate) deliveryDate.textContent = dateMap[deliveryValue] || deliveryValue;
}

document.addEventListener("change", (event) => {
  const optionInput = event.target.closest("[data-product-form] input[type='radio'], [data-product-form] select[name^='options']");
  if (!optionInput) return;

  const section = optionInput.closest("[data-section-id]");
  if (section) updateProductVariant(section);
});

function updateProductVariant(section) {
  const form = section.matches("[data-product-form]") ? section : section.querySelector("[data-product-form]");
  if (!form) return;
  const root = form.closest(".ff-pdp") || section;

  const sectionId = form.getAttribute("data-section-id");
  const variantsScript = document.querySelector(`[data-product-variants="${sectionId}"]`);
  if (!variantsScript) return;

  let variants = [];
  try {
    variants = JSON.parse(variantsScript.textContent);
  } catch {
    return;
  }

  let selectedOptions = Array.from(form.querySelectorAll(".ff-option")).map((fieldset) => {
    const checked = fieldset.querySelector("input[type='radio']:checked");
    return checked ? checked.value : "";
  });

  if (!selectedOptions.length) {
    selectedOptions = Array.from(form.querySelectorAll("[data-option-position]")).reduce((options, input) => {
      const position = Number(input.dataset.optionPosition) - 1;
      if (Number.isNaN(position)) return options;

      if (input.matches("[data-delivery-option]")) {
        if (input.classList.contains("is-selected")) options[position] = input.dataset.deliveryOption || "";
      } else if (input.matches("select")) {
        options[position] = input.value || "";
      }

      return options;
    }, []);
  }

  const matchingVariant = variants.find((variant) => {
    return selectedOptions.every((value, index) => {
      if (!value) return true;
      return normalizeOptionValue(variant.options[index]) === normalizeOptionValue(value);
    });
  });

  if (!matchingVariant) return;
  const idInput = form.querySelector('input[name="id"]');
  const submit = form.querySelector('button[type="submit"]');
  if (idInput) idInput.value = matchingVariant.id;
  if (submit) {
    submit.disabled = !matchingVariant.available;
    submit.textContent = matchingVariant.available ? "ADD TO BAG" : "Sold out";
  }

  const price = root.querySelector("[data-product-price]");
  if (price) price.innerHTML = buildMoneyHtml(matchingVariant);
}

function normalizeOptionValue(value) {
  return String(value || "")
    .toLowerCase()
    .replace(/\s+/g, "")
    .replace(/nextday|1-3days|1,2,3days/g, "next")
    .replace(/3-5days/g, "3-5")
    .replace(/18-20days|18-21days/g, "18-20");
}

function buildMoneyHtml(variant) {
  const price = formatShopMoney(variant.price);
  const compareAt = variant.compare_at_price ? formatShopMoney(variant.compare_at_price) : "";
  if (compareAt && Number(variant.compare_at_price) > Number(variant.price)) {
    return `<s>${compareAt}</s> <strong>${price}</strong>`;
  }
  return price;
}

function formatShopMoney(value) {
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) return "";
  const amount = numericValue > 100000 ? numericValue / 100 : numericValue;
  return `Rs. ${Math.round(amount).toLocaleString("en-IN")}`;
}

function restoreBrandMomentCards() {
  const section = document.querySelector(".ff-home-moment");
  if (!section || section.querySelector("[src*='farlane-brand-ovo']")) return;
  if (!/Jil Sander|Golden Goose|Maison Margiela/.test(section.textContent || "")) return;

  const cards = [
    ["OVO", "/search?q=OVO", "//mt10ih-r3.myshopify.com/cdn/shop/t/2/assets/farlane-brand-ovo.png"],
    ["Swatch", "/search?q=Swatch", "//mt10ih-r3.myshopify.com/cdn/shop/t/2/assets/farlane-brand-swatch.png"],
    ["Yeezy", "/search?q=Yeezy", "//mt10ih-r3.myshopify.com/cdn/shop/t/2/assets/farlane-brand-yeezy.png"],
  ];

  const grid = cards.map(([title, href, src]) => {
    return `<a href="${href}"><img src="${src}" alt="${title}" loading="lazy" width="1080" height="1440"><span>${title}</span></a>`;
  }).join("");

  section.innerHTML = `<h2>Brands of the moment</h2><div class="ff-home-moment__grid">${grid}</div>`;
}

function initHeroCarousels() {
  document.querySelectorAll("[data-hero-carousel]").forEach((carousel) => {
    const slides = Array.from(carousel.querySelectorAll("[data-hero-slide]"));
    if (slides.length < 2) return;
    const hero = carousel.closest(".ff-home-hero");
    const heading = hero ? hero.querySelector(".ff-home-hero__copy h1") : null;
    const text = hero ? hero.querySelector(".ff-home-hero__copy p") : null;
    const button = hero ? hero.querySelector(".ff-home-button") : null;

    let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains("is-active")));
    slides.forEach((slide, index) => slide.classList.toggle("is-active", index === activeIndex));
    updateHeroCarouselCopy(carousel, slides[activeIndex], heading, text, button);

    window.setInterval(() => {
      slides[activeIndex].classList.remove("is-active");
      activeIndex = (activeIndex + 1) % slides.length;
      slides[activeIndex].classList.add("is-active");
      updateHeroCarouselCopy(carousel, slides[activeIndex], heading, text, button);
    }, 2000);
  });
}

function updateHeroCarouselCopy(carousel, slide, heading, text, button) {
  const title = slide.dataset.title || slide.alt || "";
  const copy = slide.dataset.text || "";
  const url = slide.dataset.url || carousel.href || "/collections/all";

  if (heading && title) heading.textContent = title;
  if (text && copy) text.textContent = copy;
  if (button) button.href = url;
  carousel.href = url;
  carousel.setAttribute("aria-label", title);
}

function hydrateProductGrids() {
  hydrateCollectionGrid();
  hydrateHomeProductGrids();
}

function initHeaderSearch() {
  const forms = Array.from(document.querySelectorAll("[data-header-search]"));
  if (!forms.length) return;

  forms.forEach((form) => {
    const input = form.querySelector("[data-search-input]");
    const results = form.querySelector("[data-search-results]");
    if (!input || !results) return;

    let timer = null;
    let controller = null;

    input.addEventListener("input", () => {
      const query = input.value.trim();
      window.clearTimeout(timer);
      if (controller) controller.abort();

      if (query.length < 2) {
        results.hidden = true;
        results.innerHTML = "";
        return;
      }

      timer = window.setTimeout(() => {
        controller = new AbortController();
        const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection,page&resources[limit]=6`;
        fetch(url, { headers: { Accept: "application/json" }, signal: controller.signal })
          .then((response) => (response.ok ? response.json() : Promise.reject(response)))
          .then((data) => renderSearchSuggestions(results, data, query))
          .catch((error) => {
            if (error && error.name === "AbortError") return;
            results.hidden = true;
          });
      }, 180);
    });

    input.addEventListener("focus", () => {
      if (results.innerHTML.trim()) results.hidden = false;
    });
  });

  document.addEventListener("click", (event) => {
    if (event.target.closest("[data-header-search]") || event.target.closest("[data-search-open]")) return;
    document.querySelectorAll("[data-search-results]").forEach((results) => {
      results.hidden = true;
    });
  });
}

function renderSearchSuggestions(container, data, query) {
  const resources = data && data.resources && data.resources.results ? data.resources.results : {};
  const products = resources.products || [];
  const collections = resources.collections || [];
  const pages = resources.pages || [];
  const items = [
    ...products.map((item) => ({ type: "Product", item })),
    ...collections.map((item) => ({ type: "Collection", item })),
    ...pages.map((item) => ({ type: "Page", item })),
  ].slice(0, 8);

  if (!items.length) {
    container.innerHTML = `<span class="ff-search-suggestion--empty">No results for "${escapeHtml(query)}"</span>`;
    container.hidden = false;
    return;
  }

  container.innerHTML = items.map(({ type, item }) => {
    const title = item.title || item.name || "";
    const url = item.url || `/search?q=${encodeURIComponent(query)}`;
    const image = item.image || item.featured_image || null;
    const imageSrc = image && (image.url || image.src || image);
    return `
      <a class="ff-search-suggestion" href="${escapeHtml(url)}">
        ${imageSrc ? `<img src="${escapeHtml(imageSrc)}" alt="${escapeHtml(title)}" loading="lazy">` : `<span class="ff-search-suggestion__placeholder" aria-hidden="true"></span>`}
        <span>
          <strong>${escapeHtml(title)}</strong>
          <span>${escapeHtml(type)}</span>
        </span>
      </a>
    `;
  }).join("");
  container.hidden = false;
}

function hydrateCollectionGrid() {
  const grid = document.querySelector("[data-products-grid]");
  if (!grid || !grid.querySelector(".ff-placeholder")) return;
  const match = window.location.pathname.match(/^\/collections\/([^/?#]+)/);
  if (!match) return;
  fetchProducts(`/collections/${match[1]}/products.json?limit=24`).then((products) => {
    if (products.length) grid.innerHTML = products.map(renderHydratedProductCard).join("");
  });
}

function hydrateHomeProductGrids() {
  const grids = Array.from(document.querySelectorAll(".ff-home-products__grid"));
  if (!grids.length) return;
  grids.forEach((grid, index) => {
    if (!grid.querySelector(".ff-placeholder")) return;
    const section = grid.closest(".ff-home-products");
    let url = "/collections/brands/products.json?limit=24";
    if (section && section.classList.contains("ff-home-products--sale")) {
      url = "/collections/sale/products.json?limit=24";
    } else if (index > 1) {
      url = "/collections/sneakers/products.json?limit=4";
    }
    fetchProducts(url).then((products) => {
      if (products.length) grid.innerHTML = products.slice(0, 12).map(renderHydratedProductCard).join("");
    });
  });
}

function fetchProducts(url) {
  return fetch(`${url}${url.includes("?") ? "&" : "?"}_ff=${Date.now()}`, {
    headers: { Accept: "application/json" },
  })
    .then((response) => (response.ok ? response.json() : { products: [] }))
    .then((data) => data.products || [])
    .catch(() => []);
}

function renderHydratedProductCard(product) {
  const image = product.images && product.images[0] ? product.images[0].src : "";
  const variant = product.variants && product.variants[0] ? product.variants[0] : {};
  const price = variant.price ? formatShopMoney(variant.price) : "";
  const compareAt = variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)
    ? formatShopMoney(variant.compare_at_price)
    : "";
  const priceHtml = compareAt ? `<s>${compareAt}</s> <strong>${price}</strong>` : price;
  return `
    <article class="ff-product-card">
      <a class="ff-product-card__media" href="/products/${escapeHtml(product.handle)}">
        ${image ? `<img src="${escapeHtml(image)}" loading="lazy" alt="${escapeHtml(product.title)}">` : `<div class="ff-placeholder" aria-hidden="true"></div>`}
      </a>
      <a class="ff-product-card__info" href="/products/${escapeHtml(product.handle)}">
        <span class="ff-product-card__season">New Season</span>
        ${product.vendor ? `<span class="ff-product-card__vendor">${escapeHtml(product.vendor)}</span>` : ""}
        <span class="ff-product-card__title">${escapeHtml(product.title)}</span>
        <span class="ff-product-card__price">${priceHtml}</span>
      </a>
    </article>
  `;
}

function escapeHtml(value) {
  return String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}
